import { render, staticRenderFns } from "./EntradaTransferenciaPreparo.vue?vue&type=template&id=5954ec50&"
import script from "./EntradaTransferenciaPreparo.vue?vue&type=script&lang=js&"
export * from "./EntradaTransferenciaPreparo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports